import React from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VendorServicesShowsDetails = ({
  vendorDetails,
  FilterByIds,
  handleImageClick,
}) => {
  return (
    <div
      className="Serviceone-container"
      style={{
        padding: { xs: "2px", sm: "20px", md: "20px" },
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f9f9f9",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          color: "#333",
          marginBottom: "20px",
        }}
      >
        Vendor Details
      </h1>
      {vendorDetails
        .filter((vendor) => vendor.id === FilterByIds)
        .map((vendor) => (
          <div
            className="Serviceone-container"
            key={vendor.id}
            style={{
              border: "1px solid #ddd",
              borderRadius: "10px",
              margin: "20px auto",
              padding: "20px",
              maxWidth: "800px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2
              style={{
                color: "#007bff",
                textTransform: "uppercase",
                marginBottom: "10px",
              }}
            >
              {vendor.ServiceName}
            </h2>
            <p
              style={{
                color: "#666",
                fontSize: "14px",
                marginBottom: "15px",
              }}
            >
              <strong>Service Description:</strong> {vendor.ServiceDescription}
            </p>
            <p style={{ color: "#333" }}>
              <strong>Location:</strong> {vendor.Location}, {vendor.City}
            </p>
            <p style={{ color: "#333" }}>
              <strong>Company Name:</strong> {vendor.CompanyName}
            </p>
            <p style={{ color: "#333" }}>
              <strong>Budget:</strong>{" "}
              <span style={{ color: "#28a745" }}>{vendor.TotalBudget}</span>
            </p>
            <p style={{ color: "#333" }}>
              <strong>Status:</strong>{" "}
              <span
                style={{
                  padding: "5px 10px",
                  borderRadius: "5px",
                  backgroundColor:
                    vendor.status === "rejected" ? "#dc3545" : "#28a745",
                  color: "#fff",
                }}
              >
                {vendor.status}
              </span>
            </p>

            <h3
              style={{
                color: "#333",
                marginTop: "20px",
                borderBottom: "2px solid #ddd",
                paddingBottom: "5px",
              }}
            >
              Service Locations
            </h3>
            <p style={{ color: "#666", fontSize: "12px" }}>
              <strong>Locations:</strong>{" "}
              {JSON.parse(vendor.ServiceLocations).join(", ")}
            </p>
            <h3
              style={{
                color: "#333",
                marginTop: "20px",
                borderBottom: "2px solid #ddd",
                paddingBottom: "5px",
              }}
            >
              Social Media
            </h3>

            <div>
              {(() => {
                try {
                  // ✅ Parse once since the value is already a JSON string
                  const socialMediaArray = JSON.parse(vendor.SocialMediaHandle);

                  // ✅ Ensure it's an array and not empty
                  if (
                    !Array.isArray(socialMediaArray) ||
                    socialMediaArray.length === 0
                  ) {
                    return <p>No Social Media Links Available</p>;
                  }

                  return (
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      {socialMediaArray.map((item, index) => (
                        <li
                          key={index}
                          style={{ fontSize: "14px", marginBottom: "5px" }}
                        >
                          <strong>
                            {item.platform
                              ?.toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            :
                          </strong>{" "}
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#007bff",
                              textDecoration: "none",
                              fontSize: "13px",
                            }}
                          >
                            {item.url}
                          </a>
                        </li>
                      ))}
                    </ul>
                  );
                } catch (error) {
                  console.error("Error parsing social media data:", error);
                  return <p>Error parsing social media data</p>;
                }
              })()}
            </div>

            <h3
              style={{
                color: "#333",
                marginTop: "20px",
                borderBottom: "2px solid #ddd",
                paddingBottom: "5px",
              }}
            >
              Special Badges
            </h3>
            <ul
              style={{
                listStyleType: "disc",
                marginLeft: "20px",
                color: "#666",
              }}
            >
              <li>{JSON.parse(vendor.SpecialBadges).join(", ")}</li>
            </ul>

            {Object.entries(JSON.parse(vendor.DynamicData)).map(
              ([key, value]) => (
                <p
                  key={key}
                  style={{
                    color: "#666",
                    marginTop: "20px",
                    borderBottom: "2px solid #ddd",
                    paddingBottom: "5px",
                  }}
                >
                  <strong style={{ fontSize: "12px" }}>{key}:</strong>{" "}
                  {Array.isArray(value) ? value.join(", ") : value}
                </p>
              )
            )}
            <h3
              style={{
                color: "#333",
                marginTop: "20px",
                borderBottom: "2px solid #ddd",
                paddingBottom: "5px",
              }}
            >
              Images
            </h3>
            <div className="scrollable-container">
              {vendor.Image &&
                (() => {
                  try {
                    console.log("Raw vendor.Image:", vendor.Image);

                    // Parse vendor.Image if it's a string
                    const imageData =
                      typeof vendor.Image === "string"
                        ? JSON.parse(vendor.Image || "[]") // Prevent parsing errors
                        : vendor.Image;

                    console.log("Parsed imageData:", imageData);

                    if (Array.isArray(imageData) && imageData.length > 0) {
                      return imageData.map((img, index) => {
                        const imagePath = `${BASE_URL}/${img.path
                          .replace("/home/ubuntu/new/CEP_BackEnd/", "")
                          .replace("/home/CEP_BackEnd/", "")}`.replace(/([^:])\/\//g, "$1/"); // Prevent double slashes
                    

                        // console.log(`Image ${index + 1} path:`, imagePath);

                        return (
                          <img
                            key={index}
                            className="Serviceone-Images"
                            src={imagePath}
                            alt={`Vendor Images ${index + 1}`}
                            onClick={() => handleImageClick(imagePath)}
                          />
                        );
                      });
                    } else {
                      console.log("No images found in imageData.");

                      return (
                        <p className="fallback-message">No images available</p>
                      );
                    }
                  } catch (error) {
                    console.error("Error parsing vendor.Image:", error);
                    return <p className="error-message">Invalid image data</p>;
                  }
                })()}
            </div>

            {vendor.Video &&
              (() => {
                try {
                  console.log("Raw vendor.Video:", vendor.Video);

                  // Ensure vendor.Video is properly parsed
                  const videoData =
                    typeof vendor.Video === "string"
                      ? JSON.parse(vendor.Video || "{}") // Prevent parsing errors
                      : vendor.Video;

                  console.log("Parsed videoData:", videoData);

                  // Check if valid video data is available
                  if (videoData && videoData.path) {
                    console.log(" videoData:", videoData);

                    const videoPath = `${BASE_URL}/${videoData.path
                      .replace("/home/ubuntu/new/CEP_BackEnd/", "")
                      .replace("/home/CEP_BackEnd/", "")}`.replace(/([^:])\/\//g, "$1/"); // Prevent double slashes

                    console.log("Final video path:", videoPath);

                    return (
                      <video
                        className="h-[300px] sm:h-[100px]"
                        controls
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          cursor: "pointer",
                          borderRadius: "8px",
                          marginTop: "20px",
                        }}
                      >
                        <source
                          src={videoPath}
                          type={videoData.mimetype || "video/mp4"}
                        />
                        Your browser does not support the video tag.
                      </video>
                    );
                  }
                } catch (error) {
                  console.error("Error parsing vendor.Video:", error);
                }

                // Fallback message if no video exists
                return (
                  <p
                    style={{
                      textAlign: "center",
                      color: "#888",
                      marginTop: "20px",
                      fontStyle: "italic",
                    }}
                  >
                    There are no videos available.
                  </p>
                );
              })()}
          </div>
        ))}
    </div>
  );
};

export default VendorServicesShowsDetails;
